module.exports = __webpack_public_path__ + "img/appAsset-brand--fcDark.ecc4f3c9.svg";